import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Command } from "@air/cmdk";
import classNames from "classnames";
import { memo, useMemo } from "react";
import { SearchCommandBoardList } from "~/components/SearchCommand/SearchCommandBoardList";
import { SearchCommandSavedFilterList } from "~/components/SearchCommand/SearchCommandSavedFilterList";
import { SearchCommandSuggestionList } from "~/components/SearchCommand/SearchCommandSuggestionList";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
export const SearchCommandList = /*#__PURE__*/ memo((param)=>{
    let { isOpen, hideSuggestions, searchValue, suggestions, renderCustomContent, onSuggestionClick, onSavedFilterSelect, onBoardClick } = param;
    const { ui2 } = useTemporaryFeatureFlags();
    const showSearchCommandList = useMemo(()=>{
        var _suggestions_suggestions, _suggestions_savedFilters, _suggestions_boards;
        const hasSearchTerm = searchValue && searchValue.trim().length > 0;
        const hasSuggestions = !!(suggestions === null || suggestions === void 0 ? void 0 : (_suggestions_suggestions = suggestions.suggestions) === null || _suggestions_suggestions === void 0 ? void 0 : _suggestions_suggestions.length);
        const hasSavedFilters = !!(suggestions === null || suggestions === void 0 ? void 0 : (_suggestions_savedFilters = suggestions.savedFilters) === null || _suggestions_savedFilters === void 0 ? void 0 : _suggestions_savedFilters.length);
        const hasBoards = !!(suggestions === null || suggestions === void 0 ? void 0 : (_suggestions_boards = suggestions.boards) === null || _suggestions_boards === void 0 ? void 0 : _suggestions_boards.length);
        const hasSearchResults = hasSuggestions || hasSavedFilters || hasBoards;
        const hasCustomContent = !!renderCustomContent;
        const shouldShowForSearch = isOpen && !hideSuggestions && (hasSearchTerm || hasSearchResults);
        const shouldShowForCustomContent = isOpen && hasCustomContent;
        return shouldShowForSearch || shouldShowForCustomContent;
    }, [
        isOpen,
        hideSuggestions,
        searchValue,
        suggestions,
        renderCustomContent
    ]);
    return showSearchCommandList ? /*#__PURE__*/ _jsx("div", {
        className: classNames("grow overflow-y-auto", ui2 ? "rounded-8 border border-grey-6 bg-grey-1" : "bg-grey-1"),
        children: renderCustomContent ? renderCustomContent() : /*#__PURE__*/ _jsxs(Command.List, {
            className: classNames("flex flex-col px-4 py-3", ui2 ? "gap-0" : "gap-3"),
            "data-testid": "SEARCH_COMMAND_LIST",
            children: [
                !!onSuggestionClick && /*#__PURE__*/ _jsx(SearchCommandSuggestionList, {
                    onSelect: onSuggestionClick,
                    suggestions: suggestions === null || suggestions === void 0 ? void 0 : suggestions.suggestions
                }),
                !!(suggestions === null || suggestions === void 0 ? void 0 : suggestions.savedFilters.length) && !!onSavedFilterSelect && /*#__PURE__*/ _jsx(SearchCommandSavedFilterList, {
                    onSelect: onSavedFilterSelect,
                    savedFilters: suggestions.savedFilters
                }),
                !!(suggestions === null || suggestions === void 0 ? void 0 : suggestions.boards.length) && /*#__PURE__*/ _jsx(SearchCommandBoardList, {
                    boards: suggestions.boards,
                    onBoardClick: onBoardClick
                })
            ]
        })
    }) : null;
});
SearchCommandList.displayName = "SearchCommandList";
